import React, { useEffect } from 'react';
import Dropdown from '../../../../../Components/Dropdown/Dropdown';
import { Button } from '../../../../../Components/StyledComponents';
import Switch from '../../../../../Components/Switch/Switch';
import './BreakTime.scss';
import {cloneDeep} from 'lodash-es';

let hourOptions = []
let minuteOptions = []
let week = [
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일',
    '일요일',
    '모든 요일'
]

const BreakTime = ({info,patchBreakTimes}) => {
    const [ isAllday, setIsAllday ] = React.useState(false)//모든 요일 동일 여부
    const [ breakTime, setBreakTime ] = React.useState([
        { Day : 0 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},//0:월요일, 휴식 여부, 시작시간, 시작 분, 종료 시간, 종료 분
        { Day : 1 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},
        { Day : 2 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},
        { Day : 3 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},
        { Day : 4 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},
        { Day : 5 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},
        { Day : 6 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 0, EndMin : 0},//6:일요일
    ])

    //해당 Index의 StartHour handler
    const handleBreakStartHour = (val,i) => {
        let arr = breakTime;

        arr[i].StartHour = val;
        
        if(arr[i].EndHour < val){
            arr[i].EndHour = val + 1
        }

        setBreakTime([...arr])
    } 

    //해당 Index의 StartMin handler
    const handleBreakStartMin = (val,i) => {
        let arr = breakTime;

        arr[i].StartMin = val;

        setBreakTime([...arr])
    }

    //해당 Index의 EndHour handler
    const handleBreakEndHour = (val,i) => {
        let arr = breakTime;

        arr[i].EndHour = val;

        setBreakTime([...arr])
    } 

    //해당 Index의 EndMin handler
    const handleBreakEndMin = (val,i) => {
        let arr = breakTime;

        arr[i].EndMin = val;

        setBreakTime([...arr])
    }

    //해당 Index의 isActive handler
    const handleActive = (val,i) => {
        let arr = breakTime;

        arr[i].isActive = val;

        setBreakTime([...arr])
    }

    //모든 요일 동일/미동일 전환
    const toggleAllday = (val) => {
        setIsAllday(val)
        if(val){
            setBreakTime([
                { Day : 255 , isActive : true, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0}, //255 : 모든요일
            ])
        }else {
            setBreakTime([
                { Day : 0 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 1 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 2 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 3 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 4 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 5 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
                { Day : 6 , isActive : false, StartHour : 0, StartMin : 0, EndHour : 1, EndMin : 0},
            ])
        }
    }

    useEffect(() => {
        hourOptions = []
        minuteOptions = []

        //시간 옵션 생성
        for(let i=0;i<=23;i++){
            hourOptions.push({ key : i + '시', value : i})
            if( i < 6 ) minuteOptions.push({ key : i * 10 + '분', value : i * 10 })
        }
        if(typeof info !== 'undefined'){
            setIsAllday(cloneDeep(info.isAllday))
            setBreakTime(cloneDeep(info.DayList))
        }
    },[])

    //휴식시간 변경
    const patch = () => {
        patchBreakTimes({
            isAllday : isAllday,
            DayList : breakTime
        })
    }

    return (
        <div className='holiday-modal'>
             <div className='row'>
                <button className={`${ isAllday ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 153 }} onClick={() => toggleAllday(true)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isAllday ?
                            <img src={require('../../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        모든 요일 동일해요
                    </div>
                </button>

                <button className={`${ !isAllday ? 'selected-btn' : 'unselected-btn'}`} onClick={() => toggleAllday(false)} style={{ width : 165 }}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            isAllday ?
                            <img src={require('../../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        요일마다 달라요
                    </div>
                </button>
            </div>

            <div style={{ marginTop : 40 }}>
                {
                    breakTime.map((data,i) => {
                        return (
                            <div key={i}>
                                <div className='row' style={{ marginBottom : breakTime[i].isActive ? 16 : 32 }}>
                                    <p className='label'>{ isAllday ? '모든요일' : week[i]}</p>
                                    <Switch value={breakTime[i].isActive} onChange={(val) => handleActive(val,i)} id={`active${i}`}/>
                                </div>
                                {
                                    breakTime[i].isActive ?
                                    <>
                                        <div className='row'>
                                            <p className='label'>시작</p>
                                            <Dropdown
                                                id='break-starthour'
                                                options={hourOptions}
                                                value={breakTime[i].StartHour}
                                                onItemClick={(val) => handleBreakStartHour(val,i) }
                                                width={140}
                                                btnStyle={{ marginRight : 24 }}
                                                prefix={'시'}
                                            />
                                            <Dropdown
                                                id='break-startmin'
                                                options={minuteOptions}
                                                value={breakTime[i].StartMin}
                                                onItemClick={(val) => handleBreakStartMin(val,i) }
                                                width={140}
                                                prefix={'분'}
                                            />
                                        </div>
                                        <div className='row' style={{ marginTop : 8, marginBottom : 32 }}>
                                            <p className='label'>종료</p>
                                            <Dropdown
                                                id='break-endhour'
                                                options={hourOptions}
                                                value={breakTime[i].EndHour}
                                                onItemClick={(val) => handleBreakEndHour(val,i) }
                                                width={140}
                                                btnStyle={{ marginRight : 24 }}
                                                prefix={'시'}
                                            />
                                            <Dropdown
                                                id='break-endmin'
                                                options={minuteOptions}
                                                value={breakTime[i].EndMin}
                                                onItemClick={(val) => handleBreakEndMin(val,i) }
                                                width={140}
                                                prefix={'분'}
                                            />
                                        </div>
                                    </>
                                    : null
                                }
                                
                            </div>
                        )
                    })
                }
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default BreakTime;